module.exports = __webpack_public_path__ + "static/media/default-pack.ca76a31e.png";